module.exports = __webpack_public_path__ + "static/media/cs-login-bg.ed59c530.png";